import React from "react";
import ProductCard from "../productCard/ProductCard";
import { PrimaryPrice } from "../priceComponents";
import { COMPLEMENTARY_PRIMARY_PRICE } from "../priceComponents/priceTypes";
import { ProductContextProvider } from "../../context/product/ProductContext";
import { VariantContextProvider } from "../../context/variant/VariantContext";
import { getPrimaryImage } from "../../utils/product";
import { StylingLookProductWithStockPrice } from "../../types/productTypes/stylingLookProduct";

interface WaysToStyleProductCardProps {
  product: StylingLookProductWithStockPrice;
}

const noopSaveClick = () => undefined;

const WaysToStyleProductCard: React.FC<WaysToStyleProductCardProps> = ({
  product,
}) => {
  const { productPrice } = product;

  return (
    <ProductContextProvider products={[product]} productId={product.id}>
      <VariantContextProvider context="pdp_wts">
        <ProductCard
          product={product}
          productLink={product.pdpUrl ?? null}
          handleSaveClick={noopSaveClick}
          variantIdentifier={product.productCode}
          variantSelectorId={`ways-to-style-variant-selector-${product.id}`}
          imageWidth={163}
          primaryImageUrl={getPrimaryImage(product.images)?.url ?? ""}
          priceRenderProp={() =>
            productPrice ? (
              <PrimaryPrice
                priceData={productPrice}
                testId="product-price"
                priceType={COMPLEMENTARY_PRIMARY_PRICE}
              />
            ) : null
          }
        />
      </VariantContextProvider>
    </ProductContextProvider>
  );
};

export default WaysToStyleProductCard;
